module.exports = __webpack_public_path__ + "media/images/flags/16/Jamaica-9568279a3aca5cf8b8f665ace88bcbfb.png";